import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const NetworkFailureModal = ({ open, onClose, isSuccess, message, status , error}) => {
  const navigate = useNavigate(); 

  // Function to get the appropriate message based on status
  const getMessage = () => {
    if (status) {
      switch (status) {
        case 'success':
          return ''; 
        case 'error':
          return `${message || ''} Please log in again.`.trim();
        default:
          return '';
      }
    }
    return message || (isSuccess ? 'Successful!' : `Network failure occurred. Please log in again. ${error?.message || ''}`.trim());

  };

  // Handle button click to redirect to login page
  const handleLoginRedirect = () => {
    onClose(); // Close the modal
    localStorage.removeItem("refreshToken")
    localStorage.removeItem("auth"); // Remove authentication flag
    localStorage.removeItem("lastPage"); // Remove last visited page
    navigate('/login'); // Redirect to login page
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 300,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          textAlign: 'center',
          borderRadius: 2,
        }}
      >
        {/* Success or Error Message */}
        {isSuccess ? (
          <>
            <CheckCircleIcon color="success" sx={{ fontSize: 40 }} />
            <Typography variant="h6" sx={{ mt: 2 }}>
              {getMessage()}
            </Typography>
          </>
        ) : (
          <>
            <ErrorIcon color="error" sx={{ fontSize: 40 }} />
            <Typography variant="h6" sx={{ mt: 2 }}>
              {getMessage()}
            </Typography>
          </>
        )}

        {/* Login Button */}
        <Button
        variant="contained"
        color="error"  // Changed to error for red color
        onClick={handleLoginRedirect}
        sx={{ mt: 3 }}
        >
        Go to Login
        </Button>

      </Box>
    </Modal>
  );
};

export default NetworkFailureModal;
